export default __webpack_public_path__ + "static/media/gallery-item3-17.73b498f0.jpg";